import { comluxgroup } from '@luxuryescapes/contract-data-event-schemas'
import { trackClientEvent } from 'analytics/analytics'
import type { SupportedLoyaltyActionReward } from 'loyalty/constants/loyaltyActionRewards'
import getLoyaltyActionRewardProgress from 'loyalty/lib/getLoyaltyActionRewardProgress'

export const LOYALTY_QUESTS_TRACKING_CATEGORY = 'loyalty_quests'

interface LoyaltyActionRewardCTADestination {
  destinationUrl?: string
}

function getQuestClickProgress(reward: SupportedLoyaltyActionReward): string {
  const progress = getLoyaltyActionRewardProgress(reward)
  if (progress.kind === 'unlimited') {
    return `${progress.appliedCount}/unlimited`
  }

  return `${progress.appliedCount}/${progress.target}`
}

export function trackLoyaltyActionRewardCTA(
  reward: SupportedLoyaltyActionReward,
  destination: LoyaltyActionRewardCTADestination,
  itemPosition: number,
) {
  const pointsEarn = reward.earnEstimate?.bonusPoints ?? 0
  const progress = getQuestClickProgress(reward)
  trackClientEvent({
    category: LOYALTY_QUESTS_TRACKING_CATEGORY,
    action: 'clicked',
    subject: reward.actionName,
    type: 'interaction',
    context: [
      comluxgroup.createListItem_1_0_0({
        listName: LOYALTY_QUESTS_TRACKING_CATEGORY,
        listInstance: JSON.stringify({
          ...(destination.destinationUrl && { destinationUrl: destination.destinationUrl }),
          progress,
          pointsEarn,
        }),
        itemPosition,
      }),
    ],
  })
}
